<template>
	<div class="profitDrugSale column-me">
		<div class="tab-div row-me">
			<div class="item-tab column-me row-center" @click="clickTab(0)">
				<div class="tab-title" :class="{'tab-title-active':tabIndex===0}">利润统计</div>
				<div class="tab-line" :class="{'tab-line-active':tabIndex===0}"></div>
			</div>
			<div class="item-tab column-me row-center" @click="clickTab(1)">
				<div class="tab-title" :class="{'tab-title-active':tabIndex===1}">药品销售汇总统计</div>
				<div class="tab-line" :class="{'tab-line-active':tabIndex===1}"></div>
			</div>
			<div class="item-tab column-me row-center" @click="clickTab(2)">
				<div class="tab-title" :class="{'tab-title-active':tabIndex===2}">药品销售明细统计</div>
				<div class="tab-line" :class="{'tab-line-active':tabIndex===2}"></div>
			</div>
		</div>
		<!-- 利润统计 -->
		<div class="card-div column-me flex1" v-show="tabIndex===0">
			<div class="row-me row-center">
				<div class="width230">
					<el-input placeholder="药品名称" style="width: 100%;" clearable v-model="name1"></el-input>
				</div>
				<div class="margin-left20">开始时间：</div>
				<div class="width280">
					<el-date-picker type="date" placeholder="开始时间" value-format="YYYY-MM-DD" style="width: 100%;"
						v-model="selectDate11">
					</el-date-picker>
				</div>
				<div class="margin-left20">结束时间：</div>
				<div class="width280">
					<el-date-picker type="date" placeholder="结束时间" value-format="YYYY-MM-DD" style="width: 100%;"
						v-model="selectDate12">
					</el-date-picker>
				</div>
				<div class="btn-blue width100 btn-height40 margin-left20" @click="clickSearch">
					<el-icon>
						<search />
					</el-icon>
					查询
				</div>
				<div class="btn-blue width100 btn-height40 margin-left20" @click="clickClear">
					<el-icon>
						<delete />
					</el-icon>
					清空
				</div>
				<div class="btn-blue width100 btn-height40 margin-left20" @click="clickPrint">
					<el-icon>
						<printer />
					</el-icon>
					打印
				</div>
				<div class="btn-orange width100 btn-height40 margin-left20" @click="clickExport">导出</div>
			</div>
			<div class="table-border margin-top20">
				<div class="column-me">
					<div>
						<el-table :data="tableData1" border header-cell-class-name="table-header-style"
							cell-class-name="table-cell-style" height="68vh" show-summary>
							<el-table-column prop="name" label="药品名称" align="center"></el-table-column>
							<el-table-column prop="saleNums" label="销售数量" align="center"></el-table-column>
							<el-table-column prop="costTotalPrice" label="成本总价" align="center"></el-table-column>
							<el-table-column prop="saleTotalPrice" label="销售总价" align="center"></el-table-column>
							<el-table-column prop="profit" label="利润" align="center"></el-table-column>
						</el-table>
					</div>
				</div>
			</div>
		</div>
		<!-- 药品销售汇总统计 -->
		<div class="card-div column-me flex1" v-show="tabIndex===1">
			<div class="row-me row-center">
				<div class="width350">
					<el-input placeholder="处方订单号" style="width: 100%;" clearable v-model="number2"></el-input>
				</div>
				<div class="width350 margin-left20">
					<el-input placeholder="医院处方号" style="width: 100%;" clearable v-model="preOrder2"></el-input>
				</div>
				<div class="width350 margin-left20">
					<el-input placeholder="患者姓名" style="width: 100%;" clearable v-model="name2"></el-input>
				</div>
				<div class="width350 margin-left20">
					<el-input placeholder="医院名称" style="width: 100%;" clearable v-model="hospital2"></el-input>
				</div>
			</div>
			<div class="row-me row-center margin-top20">
				<div>开始时间：</div>
				<div class="width260">
					<el-date-picker type="date" placeholder="开始时间" value-format="YYYY-MM-DD" style="width: 100%;"
						v-model="selectDate21">
					</el-date-picker>
				</div>
				<div class="margin-left20">结束时间：</div>
				<div class="width260">
					<el-date-picker type="date" placeholder="结束时间" value-format="YYYY-MM-DD" style="width: 100%;"
						v-model="selectDate22">
					</el-date-picker>
				</div>
				<div class="flex1"></div>
				<div class="btn-blue width100 btn-height40 margin-left20" @click="clickSearch">
					<el-icon>
						<search />
					</el-icon>
					查询
				</div>
				<div class="btn-blue width100 btn-height40 margin-left20" @click="clickClear">
					<el-icon>
						<delete />
					</el-icon>
					清空
				</div>
				<div class="btn-blue width100 btn-height40 margin-left20" @click="clickPrint">
					<el-icon>
						<printer />
					</el-icon>
					打印
				</div>
				<div class="btn-orange width100 btn-height40 margin-left20" @click="clickExport">导出</div>
			</div>
			<div class="table-border margin-top20">
				<div class="column-me">
					<div>
						<el-table :data="tableData2" border header-cell-class-name="table-header-style"
							cell-class-name="table-cell-style" height="62vh" show-summary
							:summary-method="getSummaries">
							<el-table-column prop="createTime" label="传方日期" align="center" width="220">
							</el-table-column>
							<el-table-column prop="orderNo" label="处方订单号" align="center" width="250"></el-table-column>
							<el-table-column prop="prescriptionNumber" label="医院处方号" align="center" width="200">
							</el-table-column>
							<el-table-column prop="patientName" label="患者姓名" align="center"></el-table-column>
							<el-table-column prop="hospitalName" label="医院名称" align="center"></el-table-column>
							<el-table-column prop="saleTotalNums" label="销售数量合计" align="center" width="130">
							</el-table-column>
							<el-table-column prop="drugCostTotal" label="药品成本合计" align="center" width="130">
							</el-table-column>
							<el-table-column prop="drugSaleTotal" label="药品销售合计" align="center" width="130">
							</el-table-column>
							<el-table-column prop="profit" label="利润额" align="center"></el-table-column>
							<el-table-column prop="profitMargin" label="利润率" align="center"></el-table-column>
						</el-table>
					</div>
				</div>
			</div>
		</div>
		<!-- 药品销售明细统计 -->
		<div class="card-div column-me flex1" v-show="tabIndex===2">
			<div class="row-me row-center">
				<div class="width350">
					<el-input placeholder="处方订单号" style="width: 100%;" clearable v-model="number3"></el-input>
				</div>
				<div class="width350 margin-left20">
					<el-input placeholder="医院处方号" style="width: 100%;" clearable v-model="preOrder3"></el-input>
				</div>
				<div class="width350 margin-left20">
					<el-input placeholder="患者姓名" style="width: 100%;" clearable v-model="name3"></el-input>
				</div>
				<div class="width350 margin-left20">
					<el-input placeholder="医院名称" style="width: 100%;" clearable v-model="hospital3"></el-input>
				</div>
			</div>
			<div class="row-me row-center margin-top20">
				<div>开始时间：</div>
				<div class="width260">
					<el-date-picker type="date" placeholder="开始时间" value-format="YYYY-MM-DD" style="width: 100%;"
						v-model="selectDate31">
					</el-date-picker>
				</div>
				<div class="margin-left20">结束时间：</div>
				<div class="width260">
					<el-date-picker type="date" placeholder="结束时间" value-format="YYYY-MM-DD" style="width: 100%;"
						v-model="selectDate32">
					</el-date-picker>
				</div>
				<div class="width280 margin-left20">
					<el-input placeholder="项目名称" style="width: 100%;" clearable v-model="project"></el-input>
				</div>
				<div class="flex1"></div>
				<div class="btn-blue width100 btn-height40 margin-left20" @click="clickSearch">
					<el-icon>
						<search />
					</el-icon>
					查询
				</div>
				<div class="btn-blue width100 btn-height40 margin-left20" @click="clickClear">
					<el-icon>
						<delete />
					</el-icon>
					清空
				</div>
				<div class="btn-blue width100 btn-height40 margin-left20" @click="clickPrint">
					<el-icon>
						<printer />
					</el-icon>
					打印
				</div>
				<div class="btn-orange width100 btn-height40 margin-left20" @click="clickExport">导出</div>
			</div>
			<div class="table-border margin-top20">
				<div class="column-me">
					<div>
						<el-table :data="tableData3" border header-cell-class-name="table-header-style"
							cell-class-name="table-cell-style" height="62vh" show-summary
							:summary-method="getSummaries1">
							<el-table-column prop="createTime" label="传方日期" align="center" width="220">
							</el-table-column>
							<el-table-column prop="orderNo" label="处方订单号" align="center" width="250"></el-table-column>
							<el-table-column prop="prescriptionNumber" label="医院处方号" align="center" width="200">
							</el-table-column>
							<el-table-column prop="patientName" label="患者姓名" align="center"></el-table-column>
							<el-table-column prop="hospitalName" label="医院名称" align="center"></el-table-column>
							<el-table-column prop="projectName" label="项目名称" align="center"></el-table-column>
							<el-table-column prop="unit" label="单位" align="center"></el-table-column>
							<el-table-column prop="saleNums" label="销售数量" align="center"></el-table-column>
							<el-table-column prop="costUnitPrice" label="成本单价" align="center"></el-table-column>
							<el-table-column prop="costTotalPrice" label="成本总额" align="center"></el-table-column>
							<el-table-column prop="saleUnitPrice" label="销售单价" align="center"></el-table-column>
							<el-table-column prop="saleTotalPrice" label="销售总额" align="center"></el-table-column>
						</el-table>
					</div>
				</div>
			</div>
		</div>

		<!-- 打印 -->
		<div v-show="false">
			<profitDrugSalePrint ref="printPage" :printTitle="printTitle" :printType="printType" :tableData='printData'>
			</profitDrugSalePrint>
		</div>
	</div>
</template>

<script>
	import profitDrugSalePrint from './profitDrugSalePrint.vue'
	export default {
		components: {
			profitDrugSalePrint
		},
		data() {
			return {
				tabIndex: 0,
				name1: '',
				selectDate11: '',
				selectDate12: '',
				tableData1: [],
				number2: '',
				preOrder2: '',
				name2: '',
				hospital2: '',
				selectDate21: '',
				selectDate22: '',
				tableData2: [],
				number3: '',
				preOrder3: '',
				name3: '',
				hospital3: '',
				project: '',
				selectDate31: '',
				selectDate32: '',
				tableData3: [],
				printTitle: '',
				printType: '',
				printData: [],
			}
		},
		// html加载完成之前
		created() {
			this.selectDate11 = this.$method.getPreMonthDay(1)
			this.selectDate12 = this.$method.getNowDate()
			this.selectDate21 = this.$method.getPreMonthDay(1)
			this.selectDate22 = this.$method.getNowDate()
			this.selectDate31 = this.$method.getPreMonthDay(1)
			this.selectDate32 = this.$method.getNowDate()
		},
		// html加载完成后执行。
		mounted() {
			this.getData()
		},
		// 事件方法执行
		methods: {
			//获取数据
			getData() {
				if (this.tabIndex === 0) {
					this.profitStatistics()
				} else if (this.tabIndex === 1) {
					this.profitSaleTotalStatistics()
				} else if (this.tabIndex === 2) {
					this.profitSaleDetailStatistics()
				}
			},
			clickTab(index) {
				this.tabIndex = index
				this.getData()
			},
			clickSearch() {
				this.getData()
			},
			clickClear() {
				this.name1 = ''
				this.number2 = ''
				this.preOrder2 = ''
				this.name2 = ''
				this.hospital2 = ''
				this.number3 = ''
				this.preOrder3 = ''
				this.name3 = ''
				this.hospital3 = ''
				this.project = ''
				this.selectDate11 = this.$method.getPreMonthDay(1)
				this.selectDate12 = this.$method.getNowDate()
				this.selectDate21 = this.$method.getPreMonthDay(1)
				this.selectDate22 = this.$method.getNowDate()
				this.selectDate31 = this.$method.getPreMonthDay(1)
				this.selectDate32 = this.$method.getNowDate()
				this.getData()
			},
			clickPrint() {
				this.printType = this.tabIndex
				if (this.tabIndex === 0) {
					this.printTitle = '利润与药品销售-利润统计'
					let tempArray = this.$method.deepClone(this.tableData1)
					let sum = {
						costTotalPrice: this.$method.countTotal(tempArray, 'costTotalPrice'),
						name: "总计",
						profit: this.$method.countTotal(tempArray, 'profit'),
						saleNums: this.$method.countTotal(tempArray, 'saleNums'),
						saleTotalPrice: this.$method.countTotal(tempArray, 'saleTotalPrice'),
					}
					tempArray.push(sum)
					this.printData = tempArray
				} else if (this.tabIndex === 1) {
					this.printTitle = '利润与药品销售-药品销售汇总统计'
					let tempArray = this.$method.deepClone(this.tableData2)
					let sum = {
						createTime: "总计",
						drugCostTotal: this.$method.countTotal(tempArray, 'drugCostTotal'),
						drugSaleTotal: this.$method.countTotal(tempArray, 'drugSaleTotal'),
						hospitalName: "",
						orderNo: "",
						patientName: "",
						prescriptionNumber: '',
						profit: this.$method.countTotal(tempArray, 'profit'),
						profitMargin: this.$method.countTotal(tempArray, 'profitMargin'),
						saleTotalNums: this.$method.countTotal(tempArray, 'saleTotalNums'),
					}
					tempArray.push(sum)
					this.printData = tempArray
				} else if (this.tabIndex === 2) {
					this.printTitle = '利润与药品销售-药品销售明细统计'
					let tempArray = this.$method.deepClone(this.tableData3)
					let sum = {
						costTotalPrice: this.$method.countTotal(tempArray, 'costTotalPrice'),
						costUnitPrice: this.$method.countTotal(tempArray, 'costUnitPrice'),
						createTime: "总计",
						hospitalName: "",
						orderNo: "",
						patientName: "",
						prescriptionNumber: "",
						projectName: "",
						saleNums: this.$method.countTotal(tempArray, 'saleNums'),
						saleTotalPrice: this.$method.countTotal(tempArray, 'saleTotalPrice'),
						saleUnitPrice: this.$method.countTotal(tempArray, 'saleUnitPrice'),
						totalPrice: this.$method.countTotal(tempArray, 'totalPrice'),
						unit: "",
					}
					tempArray.push(sum)
					this.printData = tempArray
				}
				this.$refs.printPage.startPrint()
			},
			clickExport() {
				let token = sessionStorage.getItem('token')
				if (this.tabIndex === 0) {
					let param = {
						name: this.name1,
						start: this.selectDate11,
						end: this.selectDate12,
						token: token,
					}
					let url = this.$baseUrl + '/admin/statistics/profitStatisticsExport?' + this.$method.getParamsString(
						param)
					window.open(url)
				} else if (this.tabIndex === 1) {
					let param = {
						orderNo: this.number2,
						prescriptionNumber: this.preOrder2,
						patientName: this.name2,
						hospitalName: this.hospital2,
						start: this.selectDate21,
						end: this.selectDate22,
						token: token,
					}
					let url = this.$baseUrl + '/admin/statistics/profitSaleTotalStatisticsExport?' + this.$method
						.getParamsString(param)
					window.open(url)
				} else if (this.tabIndex === 2) {
					let param = {
						orderNo: this.number3,
						prescriptionNumber: this.preOrder3,
						patientName: this.name3,
						hospitalName: this.hospital3,
						start: this.selectDate31,
						end: this.selectDate32,
						projectName: this.project,
						token: token,
					}
					let url = this.$baseUrl + '/admin/statistics/profitSaleDetailStatisticsExport?' + this.$method
						.getParamsString(param)
					window.open(url)
				}
			},
			//获取利润统计
			profitStatistics() {
				this.$postFormRequest('/admin/statistics/profitStatistics', {
					name: this.name1,
					start: this.selectDate11,
					end: this.selectDate12,
				}).then((res) => {
					if (res) {
						this.tableData1 = res.data
					}
				}).catch((error) => {
					console.log(error)
				})
			},
			//获取药品销售汇总统计
			profitSaleTotalStatistics() {
				this.$postFormRequest('/admin/statistics/profitSaleTotalStatistics', {
					orderNo: this.number2,
					prescriptionNumber: this.preOrder2,
					patientName: this.name2,
					hospitalName: this.hospital2,
					start: this.selectDate21,
					end: this.selectDate22,
				}).then((res) => {
					if (res) {
						this.tableData2 = res.data
					}
				}).catch((error) => {
					console.log(error)
				})
			},
			//获取药品销售明细统计
			profitSaleDetailStatistics() {
				this.$postFormRequest('/admin/statistics/profitSaleDetailStatistics', {
					orderNo: this.number3,
					prescriptionNumber: this.preOrder3,
					patientName: this.name3,
					hospitalName: this.hospital3,
					start: this.selectDate31,
					end: this.selectDate32,
					projectName: this.project,
				}).then((res) => {
					if (res) {
						this.tableData3 = res.data
					}
				}).catch((error) => {
					console.log(error)
				})
			},
			// 药品销售汇总统计合计
			getSummaries({
				columns,
				data
			}) {
				const sums = [];
				columns.forEach((column, index) => {
					if (index === 0) {
						sums[index] = '总计';
						return;
					}
					if (index > 4) {
						let values = []
						//静态表头
						if (column.property) {
							values = data.map(item => Number(item[column.property]));
						}
						//动态表头
						else {
							values = data.map(function(currentValue, index1, arr) {
								return currentValue.typeVos[index - 14].total //减去前边静态的列数
							})
						}
						if (!values.every(value => isNaN(value))) {
							sums[index] = values.reduce((prev, curr) => {
								const value = Number(curr);
								if (!isNaN(value)) {
									return prev + value;
								} else {
									return prev;
								}
							}, 0);
							sums[index] = this.$method.toFixed(sums[index], 3)
						} else {
							sums[index] = 'N/A';
						}
					}
				});
				return sums;
			},
			// 药品销售明细统计
			getSummaries1({
				columns,
				data
			}) {
				const sums = [];
				columns.forEach((column, index) => {
					if (index === 0) {
						sums[index] = '总计';
						return;
					}
					if (index > 6) {
						let values = []
						//静态表头
						if (column.property) {
							values = data.map(item => Number(item[column.property]));
						}
						//动态表头
						else {
							values = data.map(function(currentValue, index1, arr) {
								return currentValue.typeVos[index - 14].total //减去前边静态的列数
							})
						}
						if (!values.every(value => isNaN(value))) {
							sums[index] = values.reduce((prev, curr) => {
								const value = Number(curr);
								if (!isNaN(value)) {
									return prev + value;
								} else {
									return prev;
								}
							}, 0);
							sums[index] = this.$method.toFixed(sums[index], 3)
						} else {
							sums[index] = 'N/A';
						}
					}
				});
				return sums;
			},
		},
		// 计算属性
		computed: {

		},
		// 侦听器
		watch: {

		},
	}
</script>

<style lang="scss" scoped>
	.profitDrugSale {
		height: 100%;

		.tab-div {
			height: 60px;
			background: #FFFFFF;
			margin: 20px 20px 0 20px;
			padding-left: 50px;

			.item-tab {
				height: 60px;
				justify-content: flex-end;
				margin-right: 50px;

				.tab-title {
					font-size: 18px;
					color: #252630;

					&-active {
						color: #215AA0;
					}
				}

				.tab-line {
					width: 20px;
					height: 4px;
					background: #FFFFFF;
					border-radius: 1px;

					&-active {
						background: #215AA0;
					}
				}
			}
		}

		.card-div {
			margin: 20px;
			background: #FFFFFF;
			box-shadow: 0 0 5px #F3F3F3;
			border-radius: 3px;
			padding: 20px;
			font-size: 18px;
			color: #252630;
		}
	}
</style>
